import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import AudioPlayer from "../../QuestionPage/AudioPlayer";
import WriteBox from "../../QuestionPage/WordBox";
import Timer from "../Timer";

// Fetching Data from the API]

// End

// Page Html
export default function WriteFromDictationMockPage({
  question,
  onInputChange,
  questionNumber,
  maxQuestion,
}) {
  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };
  const [originalWords, setOriginalWords] = useState("");
  const [Title, setTitle] = useState("");
  const [audioLink, setAudioLink] = useState("");
  const audioRef = useRef(null);
  const [text, setText] = useState("");

  // useEffect(() => {
  //   setAudioLink(question.media_link);
  //   resetAudio();
  // }, [question]);

  useEffect(() => {
    const fetchSignedUrl = async () => {
      try {
        const res = await fetch(question.media_link);
        const data = await res.json(); // expecting { url: "..." }
        setAudioLink(data.url);
        resetAudio(); // Call this after setting the new audio link
      } catch (err) {
        console.error("Failed to fetch signed audio URL:", err);
      }
    };
  
    if (question?.media_link) {
      fetchSignedUrl();
    }
  }, [question]);


  const resetAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };
  const handleTextChange = (newText) => {
    setText(newText);
    onInputChange(newText);
  };

  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h3 className="text-lg  pt-3 font-bold text-gray-900 sm:text-2xl ml-1 text-center md:text-start">
          Mock Test
        </h3>
        <h2 className=" absolute  text-1xl font-bold right-10 top-10">
          {" "}
        </h2>
        <h2 className=" absolute  text-sm font-semibold text-gray-700 right-10 top-13">
          {" "}
          Question {questionNumber} of {maxQuestion}
        </h2>
        <p className="p-2">
          You will hear a sentence. Please repeat the sentence exactly as you
          hear it. You will hear the sentence only once.
        </p>
        {audioLink && <AudioPlayer audioSrc={audioLink} audioRef={audioRef} />}

        <div className="font-bold p-2 pt-4 ml-[1250px] ">
          Time left:
          <Timer initialMinutes={10} initialSeconds={0} />
        </div>
        <WriteBox onTextChange={handleTextChange} />
      </div>
    </div>
  );
}
